import { NgModule } from "@angular/core";
import { LocalDatePipe, LocalDateTimePipe, LocalDateTimeSecondPipe, LocalTimePipe, LocalTimeSecondPipe, PhonePipe, DecimalPipe, FileSizePipe, EmailSplitPipe } from "./local-date-time-pipe";
import { CamelCaseToSpacesPipe, ElipsisTextPipe } from "./camelCaseToSpaces.pipe";
import { HighlightPipe } from "./highlight.pipe";

@NgModule({
  declarations: [LocalDatePipe, LocalDateTimePipe, CamelCaseToSpacesPipe, ElipsisTextPipe, LocalDateTimeSecondPipe, LocalTimeSecondPipe, LocalTimePipe, PhonePipe, DecimalPipe, FileSizePipe, EmailSplitPipe, HighlightPipe],
  imports: [],

  exports: [LocalDatePipe, LocalDateTimePipe, CamelCaseToSpacesPipe, ElipsisTextPipe, LocalDateTimeSecondPipe, LocalTimeSecondPipe, LocalTimePipe, PhonePipe, DecimalPipe, FileSizePipe, EmailSplitPipe, HighlightPipe],
  providers: [LocalDatePipe, LocalDateTimePipe, CamelCaseToSpacesPipe, ElipsisTextPipe, LocalDateTimeSecondPipe, LocalTimeSecondPipe, LocalTimePipe, PhonePipe, DecimalPipe, FileSizePipe, EmailSplitPipe, HighlightPipe]
})

export class CustomDatePipeModule { }
